import { Injectable } from '@angular/core';

import { Conversation } from '../../infrastructure/models/Conversation';

import { IConversationAdapter } from './adapter.interface';

@Injectable({
  providedIn: 'root',
})
export class ConversationAdapterService {
  private _adapter: IConversationAdapter<any> | null = null;

  setAdapter<T>(adapter: IConversationAdapter<T>) {
    this._adapter = adapter;
    return this;
  }

  adapt<T>(data: T, current: Conversation | null): Conversation | null {
    if (this._adapter === null) throw new Error('Adapter not set');
    if (!data || !current) return null;
    return this._adapter.adapt(data, current);
  }
}
